
import PropTypes from 'prop-types';
import React from 'react';
import { Link } from 'react-router-dom';

import { track } from '@xanadu/ui-shared/interfaces/woopra';

const AccountLink = ({
  children,
  className = '',
  trackingMessage = '',
  href,
  title,
  updateRightSidebar = () => { }
}) => (
  <Link
    className={className}
    to={href}
    onClick={() => {
      if (trackingMessage) {
        track('Right Sidebar', trackingMessage, {
          description: 'From account panel'
        });
      }

      updateRightSidebar({
        content: null,
        visible: false
      });
    }}
  >
    {title} {children}
  </Link>
);

AccountLink.propTypes = {
  children: PropTypes.node,
  title: PropTypes.string.isRequired,
  href: PropTypes.string.isRequired,
  className: PropTypes.string,
  trackingMessage: PropTypes.string,
  updateRightSidebar: PropTypes.func,
};

export default AccountLink;
